import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export interface GlobalLoadingState {
  enabled: boolean;
  isLoading: boolean;
}

const initialState: GlobalLoadingState = {
  enabled: true,
  isLoading: false,
};

export const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    setGlobalLoadingEnabled: (state, action: PayloadAction<{ enabled: boolean }>) => {
      state.enabled = action.payload.enabled;
    },
    setGlobalLoadingIsLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading;
    },
  },
});

export const { setGlobalLoadingEnabled, setGlobalLoadingIsLoading } = globalLoadingSlice.actions;

export const globalLoadingEnabledSelector = (state: RootState) => state.globalLoading.enabled;

export const globalLoadingIsLoadingSelector = (state: RootState) => state.globalLoading.isLoading;

export default globalLoadingSlice.reducer;
